import drivers from '@/services/api/drivers'
import { ACTION_TYPES as APP_ACTION_TYPES } from '@/store/modules/app'

export const MUTATION_TYPES = {
  SET_SELF: 'SET_SELF'
}

export const ACTION_TYPES = {
  GET_SELF: 'GET_SELF',
  UPDATE_SELF: 'UPDATE_SELF'
}

const state = {
  self: {
    name: 'John'
  }
}

const getters = {
  self: self => state.self
}

// TODO catch401 should be a generic?
const logoutOn401 = (response, dispatch, defaultData) => {
  if (dispatch && response && response.request && (response.request.status === 401 || response.request.status === 0)) {
    dispatch(APP_ACTION_TYPES.LOGOUT)
    window.location.reload()
  }
  return defaultData
}

const actions = {

  async [ACTION_TYPES.GET_SELF] ({ commit, dispatch }) {
    const driver = await drivers.self().catch((res) => logoutOn401(res, dispatch, null))
    commit(MUTATION_TYPES.SET_SELF, driver)
    return driver
  },

  async [ACTION_TYPES.UPDATE_SELF] ({ commit, dispatch }, driver) {
    const updated = await drivers.updateSelf(driver)

    console.log('updated', updated)
    commit(MUTATION_TYPES.SET_SELF, updated)

    return updated
  }
}

const mutations = {
  [MUTATION_TYPES.SET_SELF] (state, driver) {
    state.self = driver
  }
}

export const driversModule = {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/drivers.js